import type { CardData } from '../types'

/**
 * THE BYLINA OF BONES (Dark Slavic Folk)
 * Archetype: Midrange / Resilience / Ancestral Power
 * Unique Mechanic: Radiance (+1/+1 when an item is equipped)
 */
export const fantasyPool: CardData[] = [
  // 1-COST (7 cards)
  {
    id: 'f-1',
    name: 'Black-Wood Tracker',
    type: 'creature',
    cost: 1,
    power: 1,
    health: 1,
    keywords: ['radiance'],
    description: 'A shadow among the pines, sworn to the old ways. He sees through the dark. Radiance: +1/+1',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/tracker.png',
  },
  {
    id: 'f-2',
    name: 'Vityaz of the Dying Sun',
    type: 'creature',
    cost: 1,
    power: 1,
    health: 2,
    keywords: [],
    description: 'His steel is cold, stained with the pride of a dying sun.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/vityaz.png',
  },
  {
    id: 'f-3',
    name: 'Bone Amulet',
    type: 'item',
    cost: 1,
    power: 0,
    health: 2,
    keywords: [],
    description: '+0/+2. Carved with runes of the forgotten ones.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/item_f-1.png',
  },

  // 2-COST (12 cards)
  {
    id: 'f-4',
    name: 'Herald of Marena',
    type: 'creature',
    cost: 2,
    power: 1,
    health: 4,
    keywords: ['guard'],
    description: 'A pale goddess draped in winter pearls. She does not hunt; she simply waits for the harvest. Drain.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/marena.png',
  },
  {
    id: 'f-5',
    name: 'Iron-Bound Oprichnik',
    type: 'creature',
    cost: 2,
    power: 2,
    health: 2,
    keywords: ['radiance'],
    description: 'Dressed in the bones of fallen kings. The hound-mask laughs in the firelight. Radiance: +1/+1',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/oprichnik.png',
  },
  {
    id: 'f-6',
    name: 'Great Axe of Perun',
    type: 'item',
    cost: 2,
    power: 2,
    health: 0,
    keywords: [],
    description: '+2/+0. Blessed by the god of thunder.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/item_f-2.png',
  },
  {
    id: 'f-7',
    name: 'Grey Wolf of the Steppe',
    type: 'creature',
    cost: 2,
    power: 2,
    health: 1,
    keywords: ['charge'],
    description: 'A ravening shadow with eyes of ice. It does not hunt; it harvests.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/tundra_wolf.jpg',
  },

  // 3-COST (12 cards)
  {
    id: 'f-8',
    name: 'Red-Bearded Terem Guard',
    type: 'creature',
    cost: 3,
    power: 2,
    health: 5,
    keywords: ['guard'],
    description: 'He stands where the wood meets the stone, unmoving as the ancient oaks. Guard.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/terem_guard.png',
  },
  {
    id: 'f-9',
    name: 'Smith of the First Flame',
    type: 'creature',
    cost: 3,
    power: 2,
    health: 3,
    keywords: ['radiance'],
    description: 'Forging the sun into steel for the bogatyrs. He works in silence and shadow. Radiance: +1/+1',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/smith.png',
  },
  {
    id: 'f-10',
    name: 'Gusli of the Wind',
    type: 'item',
    cost: 3,
    power: 1,
    health: 2,
    keywords: ['ward'],
    description: '+1/+2 and Ward. Its melody protects the soul.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/item_f-3.png',
  },
  {
    id: 'f-11',
    name: 'Strike of the Firebird',
    type: 'action',
    cost: 3,
    power: null,
    health: null,
    keywords: [],
    description: 'Deal 3 damage. A burning trail of celestial feathers.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/firebird.png',
  },

  // 4-COST (10 cards)
  {
    id: 'f-12',
    name: 'Golden-Plated Bogatyr',
    type: 'creature',
    cost: 4,
    power: 4,
    health: 4,
    keywords: ['radiance', 'breakthrough'],
    description: 'The sun itself granted her this armor to shatter the dark, but it burns with a cold, unyielding fire. Radiance: +1/+1',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/bogatyr.jpg',
  },
  {
    id: 'f-13',
    name: "Tsar's Iron Plate",
    type: 'item',
    cost: 4,
    power: 1,
    health: 4,
    keywords: ['guard'],
    description: '+1/+4 and Guard. Heavy steel from the royal armory.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/item_f-4.png',
  },
  {
    id: 'f-14',
    name: 'Vasilisa the Wise',
    type: 'creature',
    cost: 4,
    power: 3,
    health: 4,
    keywords: ['drain'],
    description: 'Her beauty hides a sharp mind and ancient healing magic. Drain.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/vasilisa.jpg',
  },

  // 5-COST (6 cards)
  {
    id: 'f-15',
    name: 'Kikimora of the Dead Hearth',
    type: 'creature',
    cost: 5,
    power: 5,
    health: 7,
    keywords: ['breakthrough'],
    description: 'She does not just haunt the home; she consumes the history of those who failed it. Breakthrough.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/kikimora.png',
  },
  {
    id: 'f-16',
    name: 'Domovoi Guardian',
    type: 'creature',
    cost: 5,
    power: 4,
    health: 4,
    keywords: ['ward', 'guard'],
    description: 'A spirit of the hearth, watching from the shadows with non-human eyes. Ward, Guard.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/domovoi.png',
  },

  // 6-8 COST (3 cards) - The Finishers
  {
    id: 'f-17',
    name: 'Baba Yaga, Bone Grandmother',
    type: 'creature',
    cost: 6,
    power: 6,
    health: 6,
    keywords: ['radiance', 'drain'],
    description: 'She knows every secret of the wood. Radiance: +1/+1, Drain.',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/baba_yaga.png',
  },
  {
    id: 'f-18',
    name: 'Koshchei the Deathless',
    type: 'creature',
    cost: 8,
    power: 8,
    health: 8,
    keywords: ['ward', 'breakthrough', 'charge'],
    description: 'Legendary. He does not rule the world; he haunts it. His soul is hidden where no blade can reach.',
    rarity: 'legendary',
    faction: 'FANTASY',
    imageUrl: '/cards/fantasy/koshchei_closeup.png',
  },
]

/**
 * THE MIDNIGHT SYNDICATE (Noir)
 * Archetype: Control / Assassination / Resource Value
 * Unique Mechanic: Investigate (Adds Clue token) / Empowered (+1/+1 if holding Clue)
 */
export const noirPool: CardData[] = [
  // 1-COST (7 cards)
  {
    id: 'n-1',
    name: 'Loose-Lipped Leaker',
    type: 'creature',
    cost: 1,
    power: 1,
    health: 1,
    keywords: ['investigate'],
    description: "He's got a face only a mother could love, and a mouth that loves everyone else's secrets.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/leaker.jpg',
  },
  {
    id: 'n-2',
    name: 'Bloody Pulp',
    type: 'item',
    cost: 1,
    power: 1,
    health: 1,
    keywords: ['investigate'],
    description: 'The plot is thin, but the stains on the pages are thick with history.',
    faction: 'NOIR',
    imageUrl: '/cards/noir/bloody_pulp.png',
  },
  {
    id: 'n-3',
    name: 'Saturday Night Special',
    type: 'item',
    cost: 1,
    power: 1,
    health: 0,
    keywords: ['investigate'],
    description: "It jams more often than a jazz band, but it only needs to work once.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/saturday_night_special.png',
  },

  // 2-COST (12 cards)
  {
    id: 'n-4',
    name: 'Disillusioned Dick',
    type: 'creature',
    cost: 2,
    power: 2,
    health: 2,
    keywords: ['empowered'],
    description: "I don't look for the truth anymore; I just look for who's paying the least to hide it.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/detective.jpg',
  },
  {
    id: 'n-5',
    name: 'The Widowmaker',
    type: 'item',
    cost: 2,
    power: 3,
    health: 0,
    keywords: [],
    description: 'Fits in a garter, kills like a sledgehammer. Classy.',
    faction: 'NOIR',
    imageUrl: '/cards/noir/widowmaker.png',
  },
  {
    id: 'n-6',
    name: 'Gutter Rat',
    type: 'creature',
    cost: 2,
    power: 2,
    health: 1,
    keywords: ['lethal'],
    description: 'He’s seen things in the trash that would make a saint spit. Now he’s coming for your ankles.',
    faction: 'NOIR',
    imageUrl: '/cards/noir/gutter_rat.png',
  },
  {
    id: 'n-7',
    name: 'The Third Degree',
    type: 'action',
    cost: 2,
    power: null,
    health: null,
    keywords: [],
    description: "The light bulb isn't for seeing; it's for sweating out the lies.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/third_degree.png',
  },

  // 3-COST (12 cards)
  {
    id: 'n-8',
    name: 'The Lounge Siren',
    type: 'creature',
    cost: 3,
    power: 2,
    health: 1,
    keywords: ['lethal', 'ward'],
    description: "Her voice is like velvet, and her heart is like a razor blade. Don't ask for an encore.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/lounge_siren.png',
  },
  {
    id: 'n-9',
    name: 'Blood-Stained Trilby',
    type: 'item',
    cost: 3,
    power: 2,
    health: 2,
    keywords: [],
    description: "It doesn't just block the sun; it hides the shame.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/blood_stained_trilby.png',
  },
  {
    id: 'n-10',
    name: 'The Off-Duty Butcher',
    type: 'creature',
    cost: 3,
    power: 3,
    health: 3,
    keywords: ['investigate'],
    description: 'He protects the peace, for a very specific price. Usually involving a shovel.',
    faction: 'NOIR',
    imageUrl: '/cards/noir/off_duty_butcher.png',
  },
  {
    id: 'n-11',
    name: 'Whispers from the Morgue',
    type: 'action',
    cost: 3,
    power: null,
    health: null,
    keywords: ['investigate'],
    description: "The dead talk more than you'd think, if you know which pockets to grease.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/whispers_morgue.png',
  },

  // 4-COST (10 cards)
  {
    id: 'n-12',
    name: 'Caved-In Charlie',
    type: 'creature',
    cost: 4,
    power: 4,
    health: 4,
    keywords: ['guard', 'empowered'],
    description: "He doesn't understand the concept of 'surrender'—mostly because he doesn't understand anything over three syllables.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/caved_in_charlie.png',
  },
  {
    id: 'n-13',
    name: 'The One-Way Chauffeur',
    type: 'creature',
    cost: 4,
    power: 3,
    health: 3,
    keywords: ['charge'],
    description: 'He drives like his life is a race, which is convenient because it usually is.',
    faction: 'NOIR',
    imageUrl: '/cards/noir/oneway_chauffeur.png',
  },
  {
    id: 'n-14',
    name: "Judas's Grin",
    type: 'action',
    cost: 4,
    power: null,
    health: null,
    keywords: [],
    description: "It’s not personal—it’s just that your head is worth more than your handshake.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/judas_grin.png',
  },

  // 5-COST (6 cards)
  {
    id: 'n-15',
    name: 'Concrete Overshoes',
    type: 'action',
    cost: 5,
    power: null,
    health: null,
    keywords: [],
    description: "He won't be winning the rematch. Or walking. Ever.",
    faction: 'NOIR',
    imageUrl: '/cards/noir/concrete_overshoes.png',
  },
  {
    id: 'n-16',
    name: 'The Backroom Surgeon',
    type: 'creature',
    cost: 5,
    power: 5,
    health: 5,
    keywords: ['empowered'],
    description: 'He can stitch a wound or open a throat with the same rusty needle.',
    faction: 'NOIR',
    imageUrl: '/cards/noir/surgeon.jpg',
  },

  // 6-8 COST (3 cards)
  {
    id: 'n-17',
    name: 'The Fog-Walker',
    type: 'creature',
    cost: 7,
    power: 7,
    health: 6,
    keywords: ['lethal', 'breakthrough', 'ward'],
    description: 'He is the nightmare that wakes you up after you\'ve already died.',
    faction: 'NOIR',
    imageUrl: '/cards/noir/fogwalker.jpg',
  },
  {
    id: 'n-18',
    name: 'Don Vanni the Vulture',
    type: 'creature',
    cost: 8,
    power: 6,
    health: 10,
    keywords: ['guard', 'lethal'],
    description: 'Legendary. He doesn\'t just run the city; he digests it.',
    rarity: 'legendary',
    faction: 'NOIR',
    imageUrl: '/cards/noir/godfather.jpg',
  },
]

// Utility to build a 50-card deck based on the pool
function prepareDeck(pool: CardData[]): CardData[] {
  const deck: CardData[] = []
  // 3 copies of 1-3 costs
  pool
    .filter((c) => c.cost <= 3 && c.rarity !== 'legendary')
    .forEach((card) => {
      deck.push({ ...card, id: card.id + '-1' })
      deck.push({ ...card, id: card.id + '-2' })
      if (card.cost <= 2) deck.push({ ...card, id: card.id + '-3' })
    })
  // 2 copies of 4-5 costs
  pool
    .filter((c) => (c.cost === 4 || c.cost === 5) && c.rarity !== 'legendary')
    .forEach((card) => {
      deck.push({ ...card, id: card.id + '-1' })
      deck.push({ ...card, id: card.id + '-2' })
    })
  // 1 copy of high end and Legendaries
  pool
    .filter((c) => c.cost >= 6 || c.rarity === 'legendary')
    .forEach((card) => {
      deck.push({ ...card, id: card.id + '-unique' })
    })

  return deck.slice(0, 40)
}

/**
 * THE NEON NIGHTS (Neon)
 * Archetype: Aggressive / High Speed / All-in
 * Unique Mechanic: Overdrive (+2 Power if Magicka is 0)
 */
/**
 * SUNSET INVESTIGATIONS (Sunset)
 * Archetype: Aggressive / High Speed / Action Hero
 * Unique Mechanic: Overdrive (+2 Power if Magicka is 0)
 * Vibe: 1980s Hawaii PI, Fast Cars, Loud Shirts, Big Mustaches.
 */
export const sunsetPool: CardData[] = [
  // 1-COST (3 cards)
  {
    id: 's-p1',
    name: 'Island Informant',
    type: 'creature',
    cost: 1,
    power: 1,
    health: 1,
    keywords: ['overdrive'],
    description: 'He knows everyone on the beach. Overdrive: +2 Power (He talks faster when pressured).',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/informant.png',
  },
  {
    id: 's-p2',
    name: 'Flashy Badge',
    type: 'action',
    cost: 1,
    power: null,
    health: null,
    keywords: [],
    description: 'Freeze! It usually works... eventually.',
    faction: 'SUNSET',
  },
  {
    id: 's-p3',
    name: 'Sucker Punch',
    type: 'action',
    cost: 1,
    power: null,
    health: null,
    keywords: [],
    description: 'They never see "The Right Hook" coming. Overdrive: Deal 3 instead.',
    faction: 'SUNSET',
  },

  // 2-COST (4 cards)
  {
    id: 's-p4',
    name: 'Red Convertible',
    type: 'creature',
    cost: 2,
    power: 2,
    health: 1,
    keywords: ['charge'],
    description: '0 to 60 in "Hold my beer".',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/convertible.png',
  },
  {
    id: 's-p5',
    name: 'Club Singer',
    type: 'creature',
    cost: 2,
    power: 2,
    health: 2,
    keywords: ['overdrive'],
    description: 'She hits the high notes when the chips are down. Overdrive: +2 Power.',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/singer.png',
  },
  {
    id: 's-p6',
    name: 'Service Pistol',
    type: 'item',
    cost: 2,
    power: 2,
    health: 0,
    keywords: [],
    description: 'Trusty M1911. Never jams, mostly.',
    faction: 'SUNSET',
  },
  {
    id: 's-p7',
    name: 'Beach Bum',
    type: 'creature',
    cost: 2,
    power: 1,
    health: 3,
    keywords: ['ward'],
    description: 'He’s survived three hurricanes and twelve bar fights.',
    faction: 'SUNSET',
  },

  // 3-COST (4 cards)
  {
    id: 's-p8',
    name: 'Vietnam Buddy',
    type: 'creature',
    cost: 3,
    power: 3,
    health: 3,
    keywords: ['guard'],
    description: 'I got your back, brother. Always.',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/buddy.png',
  },
  {
    id: 's-p9',
    name: 'Loose Cannon Cop',
    type: 'creature',
    cost: 3,
    power: 2,
    health: 4,
    keywords: ['overdrive'],
    description: 'The chief took his badge, but not his attitude. Overdrive: +2 Power.',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/cop.png',
  },
  {
    id: 's-p10',
    name: 'Hawaiian Shirt',
    type: 'item',
    cost: 3,
    power: 1,
    health: 1,
    keywords: ['ward', 'overdrive'],
    description: 'So loud it blinds the enemy. Overdrive: +2/+2 bonus.',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/shirt.png',
  },
  {
    id: 's-p11',
    name: 'Mustache Wax',
    type: 'item',
    cost: 3,
    power: 3,
    health: 0,
    keywords: ['breakthrough'],
    description: '+3/+0. The source of all power.',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/wax.png',
  },

  // 4-COST (3 cards)
  {
    id: 's-p12',
    name: 'Estate Caretaker',
    type: 'creature',
    cost: 4,
    power: 4,
    health: 4,
    keywords: ['guard', 'overdrive'],
    description: 'Sends the dogs if you step on the grass. Overdrive: +2 Power.',
    faction: 'SUNSET',
  },
  {
    id: 's-p13',
    name: 'Private Chopper',
    type: 'creature',
    cost: 4,
    power: 3,
    health: 3,
    keywords: ['charge', 'breakthrough'],
    description: 'Whatever you do, don\'t touch the controls!',
    faction: 'SUNSET',
  },
  {
    id: 's-p14',
    name: 'Montage Sequence',
    type: 'action',
    cost: 4,
    power: null,
    health: null,
    keywords: [],
    description: 'Cue the synth music. Total board reset.',
    faction: 'SUNSET',
  },

  // 5-COST (2 cards)
  {
    id: 's-p15',
    name: 'The Sidekick',
    type: 'creature',
    cost: 5,
    power: 4,
    health: 5,
    keywords: ['charge', 'ward'],
    description: 'He does the research, you take the credit.',
    faction: 'SUNSET',
  },
  {
    id: 's-p16',
    name: 'Adrenaline Shot',
    type: 'creature',
    cost: 5,
    power: 5,
    health: 5,
    keywords: ['overdrive', 'breakthrough'],
    description: 'Just getting started. Overdrive: +2 Power.',
    faction: 'SUNSET',
  },

  // 6-8 COST (2 cards)
  {
    id: 's-p17',
    name: 'The Red Stallion',
    type: 'creature',
    cost: 7,
    power: 7,
    health: 7,
    keywords: ['charge', 'breakthrough', 'overdrive'],
    description: 'The fastest car on the island. Overdrive: +4 Power.',
    rarity: 'legendary',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/stallion.png',
  },
  {
    id: 's-p18',
    name: 'The P.I.',
    type: 'creature',
    cost: 8,
    power: 6,
    health: 10,
    keywords: ['ward', 'lethal', 'guard'],
    description: 'Legendary. Just a guy in paradise making ends meet.',
    rarity: 'legendary',
    faction: 'SUNSET',
    imageUrl: '/cards/sunset/pi.png',
  },
]

export const nordWarriorDeck: CardData[] = prepareDeck(fantasyPool)
export const highElfMageDeck: CardData[] = prepareDeck(fantasyPool) // Defaulting to fantasy for now
export const noirDetectiveDeck: CardData[] = prepareDeck(noirPool)
export const sunsetDetectiveDeck: CardData[] = prepareDeck(sunsetPool)
